import React from 'react';

const AppNotAccessible = ({ onRetry, isRetrying = false }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <svg 
            className="w-8 h-8 text-red-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" 
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          App Not Accessible
        </h1>

        {/* Description */}
        <div className="text-gray-600 mb-6 space-y-2">
          <p>
            We're having trouble connecting to our servers right now.
          </p>
          <p className="text-sm">
            This could be due to:
          </p>
          <ul className="text-sm text-left space-y-1 mt-2">
            <li>• Network connectivity issues</li>
            <li>• Server maintenance</li>
            <li>• Configuration problems</li>
          </ul>
        </div>

        {/* Retry Button */}
        <button
          onClick={onRetry}
          disabled={isRetrying}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center"
        >
          {isRetrying ? (
            <>
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Retrying...
            </>
          ) : (
            'Try Again'
          )}
        </button>

        {/* Additional Info */}
        <div className="mt-6 text-xs text-gray-500">
          <p>
            If this problem persists, please check your internet connection 
            or try again later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AppNotAccessible;
